import * as eventService from './eventService'

export default eventService;